import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classnames';
import { SecondaryLink } from '@bibliocommons/base-links';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { sendAnalyticsEvents } from '@bibliocommons/utils-analytics';
import { tagsEventComposer } from '@bibliocommons/analytics-event-composers';

import './TagList.scss';

const { composeTagClickEvent } = tagsEventComposer;

function handleTagClick(tagName) {
  sendAnalyticsEvents(composeTagClickEvent({ tagName }));
}

export default class TagList extends React.PureComponent {
  renderTag(tag) {
    const { tagType: TagType } = this.props;
    const tagName = tag.get('tag');
    const searchQuery = `/v2/search?query=${tagName}&searchType=tag`;
    const tagCount = tag.get('count');

    return (
      <li key={`${tagName}-${tagCount}`} className="tag-item">
        <TagType
          className="tag-item-link"
          dataKey="tag-item-link"
          href={searchQuery}
          rel="noopener noreferrer"
          handleClick={() => handleTagClick(tagName)}
        >
          {tagName} ({tagCount})
        </TagType>
      </li>
    );
  }

  render() {
    return (
      <ul
        className={cn('cp-tag-list', {
          'tag-list--stacked': this.props.stacked
        })}
      >
        {this.props.tags.map(tag => this.renderTag(tag))}
      </ul>
    );
  }
}

TagList.propTypes = {
  tags: ImmutablePropTypes.list.isRequired,
  tagType: PropTypes.func,
  stacked: PropTypes.bool
};

TagList.defaultProps = {
  tagType: SecondaryLink
};
